import { useEffect } from "react";
import Contact from "../components/Contact";

export default function ContactPage() {
  useEffect(() => {
    const contactOverlay = document.querySelector(".contact-overlay");

    if (contactOverlay) {
      contactOverlay.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return <Contact />;
}
